var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1346_9199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 13.334H25.0167",
    stroke: "#00A85B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3346 6.66602H11.668C8.90654 6.66602 6.66797 8.90459 6.66797 11.666V28.3327C6.66797 31.0941 8.90654 33.3327 11.668 33.3327H28.3346C31.0961 33.3327 33.3346 31.0941 33.3346 28.3327V11.666C33.3346 8.90459 31.0961 6.66602 28.3346 6.66602Z",
    stroke: "#00A85B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66797 24.9999L13.3346 18.3333C14.0947 17.6018 14.957 17.2168 15.8346 17.2168C16.7123 17.2168 17.5745 17.6018 18.3346 18.3333L26.668 26.6666",
    stroke: "#00A85B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.332 23.3339L24.9987 21.6672C25.7588 20.9358 26.621 20.5508 27.4987 20.5508C28.3764 20.5508 29.2386 20.9358 29.9987 21.6672L33.332 25.0006",
    stroke: "#00A85B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1346_9199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImg);
export default __webpack_public_path__ + "static/media/add-img.201f898e1f7d93b5a2ad0971f5db5e29.svg";
export { ForwardRef as ReactComponent };